import { render, staticRenderFns } from "./DashedAddResource.vue?vue&type=template&id=7422dd12&scoped=true&"
import script from "./DashedAddResource.vue?vue&type=script&lang=js&"
export * from "./DashedAddResource.vue?vue&type=script&lang=js&"
import style0 from "./DashedAddResource.vue?vue&type=style&index=0&id=7422dd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422dd12",
  null
  
)

export default component.exports